import React, { useState, useEffect, memo } from "react";
import "../ViewEdit/Test.css";
import axiosInst from "../../../Config";

const PatientForm = ({ setIsFormOpened, formData, setFormData, onSuccess }) => {
  const [localData, setLocalData] = useState(formData);

  useEffect(() => {
    setLocalData(formData);
  }, [formData]);

  if (!localData || !localData.questions) return null;

  const isSaved = localData.isSaved === true;

  const handleSelect = (qId, optionId) => {
    if (isSaved) return;

    const updated = {
      ...localData,
      questions: localData.questions.map((q) =>
        q.question_id === qId ? { ...q, selected_option: optionId } : q,
      ),
    };

    setLocalData(updated);
  };

  const allAnswered = localData?.questions?.every(
    (q) =>
      q.selected_option !== undefined &&
      q.selected_option !== null &&
      q.selected_option !== "" &&
      q.selected_option !== 0,
  );

  const handleSave = () => {
    const cleanQuestions = localData.questions.map((q) => ({
      question_id: q.question_id,
      selected_option: q.selected_option,
      options: q.options.map((opt) => ({
        option_id: opt.option_id,
        score: opt.score,
      })),
    }));

    const payload = {
      pid: localData.pid,
      portalDocsRowId: localData.document_id,
      assess_form: localData.assess_form,
      questions: cleanQuestions,
    };

    axiosInst
      .post("/vozo/patient/savePatientDocForm", payload)
      .then(() => {
        // alert("Assessment saved successfully");

        setFormData({
          ...localData,
          isSaved: true,
        });

        setIsFormOpened(false);
        if (onSuccess) onSuccess();
      })

      .catch(() => {
        // alert("Save failed");
      });
  };

  return (
    <div className="pf-page">
      <div className="pf-title">{localData.assessment_name}</div>

      <div className="pf-box">
        <div className="pf-inner-title">{localData?.assess_form}</div>

        <div className="pf-scroll">
          {localData.questions.map((q, index) => (
            <div key={q.question_id} className="pf-q-block">
              <div className="pf-q-title">Question {index + 1} :</div>

              <div className="pf-q-text">{q.question}</div>

              <div className="pf-options">
                {q.options.map((opt) => (
                  <label key={opt.option_id} className="pf-option-row">
                    <input
                      type="radio"
                      name={`question-${q.question_id}`}
                      checked={String(q.selected_option) === String(opt.option_id)}
                      onChange={() =>
                        handleSelect(q.question_id, opt.option_id)
                      }
                      disabled={isSaved}
                      className="pf-checkbox"
                    />

                    <span>{opt.option}</span>
                  </label>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="pf-footer">
        <button className="pf-cancel" onClick={() => setIsFormOpened(false)}>
          Close
        </button>

        {!isSaved && (
          <button
            className="pf-save"
            onClick={handleSave}
            disabled={!allAnswered}
            style={{
              opacity: allAnswered ? 1 : 0.5,
              cursor: allAnswered ? "pointer" : "not-allowed",
            }}
          >
            Save
          </button>
        )}
      </div>
    </div>
  );
};

export default memo(PatientForm);
